import {
  Button,
  Box,
  IconButton,
  Table, 
  TableCell, 
  TableContainer,
  TableHead, 
  TableBody, 
  TableRow,
  TablePagination,
  Tooltip,
  Paper,
  Collapse,
  styled,
  Toolbar,
  TableSortLabel,
  MenuItem,
  MenuList,
  Checkbox,
  InputBase,
  alpha,
  TextField,
  Divider,
  Menu,
} from "@mui/material";
import { visuallyHidden } from '@mui/utils';
import SearchIcon from '@mui/icons-material/Search';
import AssessmentIcon from '@mui/icons-material/Assessment';
import BuildIcon from '@mui/icons-material/Build';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import AlignHorizontalLeftIcon from '@mui/icons-material/AlignHorizontalLeft';
import FilterListIcon from "@mui/icons-material/FilterList";
import moment from 'moment';
// import MUIDataTable from 'mui-datatables';
import React, { useEffect, useState, Dispatch, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { setAccounts } from '../actions/accounts';
import { setUserProfiles } from "../actions/userProfiles";
import { setUserRoles } from '../actions/userRoles';
import { 
  deleteUserProfile, 
  getAccounts, 
  getAllUserProfiles, 
  getDisplayName, 
  getUserParents, 
  getUserProfile, 
  getUserProfiles, 
  getUserRoles, 
  updateFirebaseAccountInfo, 
  getAccountInfos, 
  getMissionDomain,
} from "../api";
import AddUserDialog from '../components/AddUserDialog';
import DeleteDialog from '../components/DeleteDialog';
import { EditDemoMissionDialog } from '../components/EditDemoMissionDialog';
import GamePreferenceDialog from "../components/GamePreferenceDialog";
import SimpleSnackBar, { SnackBarProp } from "../components/SimpleSnackBar";
import { AppState } from "../reducers";
import { LoadableAccountData } from '../reducers/accounts';
import { LoadableProfileData } from '../reducers/userProfiles';
import { StyledCircularProgress, StyledContainer } from "../StyledComponents";
import SubmitGamePreferenceSnackBar from "../SubmitGamePreferenceSnackBar";
import { MocaScore, UserProfile } from "../types/UserProfile";
import { RoleType, UserRole } from "../types/UserRole";
import { AccountData } from './AccountsPage';
import { AccountInfo } from '../types/AccountInfo';
import { setAccountInfos } from '../actions/accountInfos';
import { firebaseUser } from "../firebase";
import { setMissionMetadata } from "../actions/missionMetadata";
import { MissionMetadata, MissionType } from "../types/MissionType";
import ResetPasswordDialog from "../components/ResetPasswordDialog";
import { useTranslation } from "react-i18next";

interface Center {
  uid: string;
  name: string;
}

export interface LoadedData {
  kind: "loaded";
  data: (Center | null)[];
}

export interface LoadingData {
  kind: "loading";
}

export interface LoadingDataError {
  kind: "error";
  error?: string;
}

export type LoadableAllCenterData =
  | LoadedData
  | LoadingData
  | LoadingDataError
;

export default function UserProfilesPage(props: { setTitle: Dispatch<React.SetStateAction<string>>}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const closeErrorSnackBar = () => {
    setSnackBar({ ...snackBar, "open": false });
  }

  const [snackBar, setSnackBar] = useState<SnackBarProp>({
    open: false,
    onClose: closeErrorSnackBar,
    message: "",
    variant: undefined
  });

  const dataAttributes: DataAttributes[] = [
    { id: "gender", label: "gender", values: ["all", "M", "F", "norecord"] },
    { id: "year_of_birth", label: "common", values: ["all", "1940", "1950", "1960", "1970", "1980", "norecord"],
      boundary: [
        { id: "after", values: ">" },
        { id: "orAfter", values: ">=" },
        { id: "in", values: "=" },
        { id: "orBefore", values: "<=" },
        { id: "before", values: "<" },
      ]},
    { id: "moca_score", label: "common", values: ["all", "30", "25", "20", "15", "10", "5", "0", "norecord"],
      boundary: [
        { id: "greater", values: ">" },
        { id: "greaterOrEqual", values: ">=" },
        { id: "equal", values: "=" },
        { id: "lowerOrEqual", values: "<=" },
        { id: "lower", values: "<" },
      ]},
    { id: "dementia_diagnosis", label: "dementia_diagnosis", values: ["all", "healthy", "mci", "mild_dementia", "moderate_dementia", "severe_dementia", "unknown", "norecord"] },
    { id: "is_dementia_mode", label: "common", values: ["all", "yes", "no"] },
    { id: "occupation", label: "common", values: ["all", "withRecord", "norecord"] },
    { id: "use_smartphone_level", label: "use_smartphone_level", values: ["all", "no_knowledge", "newbie", "familiar", "norecord"] },
    { id: "education_level", label: "education_level", values: ["all", "no_education", "primary_school", "secondary_school", "university", "above_university", "norecord"] },
    { id: "mahjong_level", label: "mahjong_level", values: ["all", "no_knowledge", "newbie", "familiar", "norecord"] },
    { id: "smoke", label: "common_level", values: ["all", "no", "always", "sometimes", "seldom", "norecord"] },
    { id: "drink_alcohol", label: "common_level", values: ["all", "no", "always", "sometimes", "seldom", "norecord"] },
  ]

  const loggedInUser = useSelector<AppState, firebaseUser | null>(state => state.loggedInUser);
  const userRole = useSelector<AppState, RoleType | null>(state => state.userRole);
  const userProfiles = useSelector<AppState, LoadableProfileData>(state => state.userProfiles);
  const [openGamePreferenceDialog, setOpenGamePreferenceDialog] = useState(false);
  const [openSubmitGamePreferenceSnackBar, setOpenSubmitGamePreferenceSnackBar] = useState(false);
  const [selectedUser, setSelectedUser] = useState<UserProfile>();
  const [selectedUserId, setSelectedUserId] = useState<string>();
  const [isAddUserModalOpen, setIsAddUserModalOpen] = useState<boolean>(false);
  const [isResetPasswordDialogOpen, setIsResetPasswordDialogOpen] = useState<boolean>(false);
  const [userParents, setUserParents] = useState<Array<{ "userId": string, "centerId": string }>>();
  const [userCenter, setUserCenter] = useState<Array<{ "userId": string, "center": string | null }>>();
  const [deleteDialogOpen, setDeleteDialogOpen] = useState<boolean>(false);
  const [isEditDemoMissionDialogOpen, setIsEditDemoMissionDialogOpen] = useState<boolean>(false);
  const [allCenter, setAllCenter] = useState<LoadableAllCenterData>();
  const accounts = useSelector<AppState, LoadableAccountData>(state => state.accounts);
  const userRoles = useSelector<AppState, UserRole[] | null>(state => state.userRoles);
  // const accountInfos = useSelector<AppState, AccountInfo[] | null>(state => state.accountInfos);
  const missionMetadata = useSelector<AppState, { metadata: MissionMetadata | null; domainMission: { [key: string]: MissionType[] } }>(state => state.missionMetadata);

  function handleOpenGamePreferenceDialog(userProfile: UserProfile | undefined) {
    if (userRole === "admin") {
      if (userProfiles !== undefined) {
        // console.log(selectedUser?.center)
        setSelectedUser(userProfile);
        setOpenGamePreferenceDialog(true);
      }
    }
    else {
      if (userProfiles !== undefined) {
        setSelectedUser(userProfile);
        setOpenGamePreferenceDialog(true);
      }
    }
  }

  const handleOpenEditUserDialog = (userProfile: UserProfile | undefined) => {
    if (userProfiles !== undefined) {
      setSelectedUser(userProfile);
      setIsAddUserModalOpen(true);
    }
  }

  const handleGamePreferenceDialogClose = (submitted?: boolean) => {
    if (submitted === true) { setOpenSubmitGamePreferenceSnackBar(true); }
    setOpenGamePreferenceDialog(false);
  };

  const handleDeleteProfile = async (uid: string) => {
    try {
      if (loggedInUser !== null) {
        await deleteUserProfile(uid);
        await updateFirebaseAccountInfo({ uid: uid, disabled: true });
        setDeleteDialogOpen(false);
        setSnackBar({
          ...snackBar,
          open: true,
          message: t("msg.deleted_successfully"),
          variant: "success",
        });
        _getUserProfiles();
      }
    } catch (e) {
      console.log(e);
    }
  }

  const handleSubmitGamePreferenceSnackBarClose = () => {
    setSelectedUser(undefined);
    setOpenSubmitGamePreferenceSnackBar(false);
  };

  useEffect(() => {
    if (userRole === "admin") {
      setAllCenter({ kind: "loading" });
      _setAccounts();
    }

    async function setMissionMD() {
      if (!missionMetadata.metadata) dispatch(setMissionMetadata(await getMissionDomain()));
    }
    setMissionMD();
    props.setTitle("users");
  }, [])

  useEffect(() => {
    _getUserProfiles();
  }, [isAddUserModalOpen])

  const _getUserProfiles = async () => {
    if (userProfiles.kind !== "loaded") {
      dispatch(setUserProfiles({ kind: "loading" }))
    }
    try {
      if (loggedInUser !== null) {
        if (userRole === "trial_center" || userRole === "center") {
          await getUserProfiles(loggedInUser).then((data) => {
            dispatch(setUserProfiles({ kind: "loaded", data: data }));
          })
        } else if (userRole === "admin") {
          await getAllUserProfiles().then((data) => {
            dispatch(setUserProfiles({ kind: "loaded", data: data }));
          })
          await getUserParents().then((data) => {
            if (data !== null) {
              setUserParents(data);
            }
          })
        } else {
          const data = await getUserProfile(loggedInUser.uid);
          if (data !== null) {
            dispatch(setUserProfiles({ kind: "loaded", data: [data] }));
          }
        }
      }
    } catch (e: any) {
      dispatch(setUserProfiles({ kind: "error", error: e }))
    }
  }

  useEffect(() => {
    if (accounts.kind === "loaded" && userRoles) {
      const temp = userRoles.filter(x => (x.role === "trial_center" || x.role === "center"));
      let centerArr = temp.map(x => {
        const tempAccount = accounts.data.find(y => y.uid === x.uid);
        if (tempAccount !== undefined && tempAccount.displayName !== undefined && tempAccount.displayName !== "") {
          return { uid: tempAccount.uid, name: tempAccount.displayName };
        }
        return null;
      })
      centerArr.filter((x): x is Center => x !== null);
      setAllCenter({ kind: "loaded", data: centerArr });
      // console.log(centerArr)
    }
  }, [accounts, userRoles])

  const _setAccounts = async () => {
    dispatch(setAccounts({ kind: "loading" }));
    try {
      let data = await getAccounts() as AccountData[];
      let mapped_data = data.map(x => {
        return {
          ...x,
          creationTime: moment.utc(x.metadata.creationTime).local().format('YYYY MMM Do HH:mm:ss'),
          lastSignInTime: moment.utc(x.metadata.lastSignInTime).local().format('YYYY MMM Do HH:mm:ss')
        }
      }) as AccountData[];
      dispatch(setAccounts({ kind: "loaded", data: mapped_data }));
      dispatch(setUserRoles( await getUserRoles()));
    } catch (e: any) {
      dispatch(setAccounts({ kind: "error", error: e }));
    }
  }

  useEffect(() => {
    if (userParents !== undefined) {
      _setUserCenter(userParents);
    }
  }, [userParents])

  const _setUserCenter = async (userParents: { "userId": string, "centerId": string }[]) => {
    let userCenters: { "userId": string, "center": string | null }[] = await Promise.all(userParents.map(async row => {
      try {
        const center = await getDisplayName(row.userId);
        return { "userId": row.userId, "center": center };
      } catch (e) {
        return { "userId": row.userId, "center": "" };
      }
    }))
    setUserCenter(userCenters);
  }

  useEffect(() => {
    if (userProfiles !== undefined && userProfiles.kind === "loaded") {
      setProfileCenter(userProfiles.data);
    }
  }, [userCenter])

  const setProfileCenter = async (data: UserProfile[]) => {
    let temp = await Promise.all(data.map(async x => {
      let temp2 = { ...x, "center": await getCenter(x.user_id) }
      return temp2;
    }))
    dispatch(setUserProfiles({ kind: "loaded", data: temp }));
  }

  const getCenter = async (userId: string) => {
    if (userCenter !== undefined && userRoles != null && accounts.kind === 'loaded') {
      const temp = userCenter.find(x => x.userId === userId);
      if (temp !== undefined && temp.center !== null) return temp.center;

      const role = userRoles.find(x => x.uid === userId);
      if (role !== undefined && (role.role === 'trial_center' || role.role === 'center')) {
        const tempAccount = accounts.data.find(x => x.uid === userId);
        if (tempAccount !== undefined) return tempAccount.displayName;
      }
    }
    return "";
  }

  const closeAddUserModal = () => {
    setSelectedUser(undefined);
    setIsAddUserModalOpen(false);
  }

  const handleDeleteDialogOpen = (userProfile: UserProfile | undefined) => {
    if (userProfile !== undefined) {
      setSelectedUser(userProfile);
      setDeleteDialogOpen(true);
    }
  }

  const handleDeleteDialogClose = () => {
    setDeleteDialogOpen(false);
  }

  const handleOpenResetPasswordDialog = (uid: string) => {
    setSelectedUserId(uid);
    setIsResetPasswordDialogOpen(true);
  }

  const closeResetPasswordDialog = () => {
    setIsResetPasswordDialogOpen(false);
  }

  const handleEditDemoMissionDialog = (uid: string) => {
    setSelectedUserId(uid);
    setIsEditDemoMissionDialogOpen(true);
  }

  const closeEditDemoMissionDialog = () => {
    setIsEditDemoMissionDialogOpen(false);
  }

  const handleAddUserModalOpen = async () => {
    if (userRole !== "admin") {
      const _accountInfos = await getAccountInfos();
      dispatch(setAccountInfos(_accountInfos));
      if (_accountInfos !== null && loggedInUser !== null) {
        if (userProfiles.kind !== 'loaded') {
          setSnackBar({
            ...snackBar,
            open: true,
            message: t("msg.loading_plz_wait"),
            variant: "info",
          });
          return;
        }

        const temp = _accountInfos.find(x => x.uid === loggedInUser.uid);
        if (temp !== undefined && (temp.quota === undefined || (temp.quota !== undefined && userProfiles.kind === 'loaded' && userProfiles.data.length < temp.quota))) {
          setIsAddUserModalOpen(true);
        } else {
          setSnackBar({
            ...snackBar,
            open: true,
            message: t("msg.exceed_limit"),
            variant: "warning",
          });
        }
      } else {
        if (_accountInfos === null) {
          setSnackBar({
            ...snackBar,
            open: true,
            message: t("msg.failed_to_load"),
            variant: "error",
          });
        }
        if (loggedInUser === null) {
          setSnackBar({
            ...snackBar,
            open: true,
            message: t("msg.failed_to_load_login"),
            variant: "error",
          });
        }
      }
    } else {
      setIsAddUserModalOpen(true);
    }
  }

  // Table States
  const [page, setPage] = useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = useState<number>(10);
  const [order, setOrder] = useState<"asc" | "desc">("asc");
  const [orderBy, setOrderBy] = useState<string>("UID");
  const [tableProfiles, setTableProfiles] = useState<UserProfile[]>([]);
  const [tableTempProfiles, setTableTempProfiles] = useState<UserProfile[]>([]);
  const [allProfiles, setAllProfiles] = useState<UserProfile[]>([]);

  useEffect(() => {
    if (userProfiles && userProfiles.kind === "loaded") {
      setTableProfiles(userProfiles.data);
      setTableTempProfiles(userProfiles.data);
      setAllProfiles(userProfiles.data);
    }
  }, [userProfiles])

  useEffect(() => {
    handleDataFiltering();
  }, [allProfiles])

  // Table functions
  const handleChangePage = (e: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (e: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(+e.target.value);
    setPage(0);
  };

  const handleRequestSort = (e: unknown, property: string) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  }

  // filtered: determine the element to show or not to show
  // roleValid: check user role whether the user have permission to view the specific element
  const [columns, setColumns] = useState<Column[]>([
    { id: "uid", minWidth: 50, roleValid: "admin", filtered: false },
    { id: "name", minWidth: 50, filtered: false },
    { id: "center", minWidth: 500, roleValid: "admin", filtered: false },
    { id: "gender", minWidth: 100, filtered: true },
    { id: "year_of_birth", minWidth: 150, filtered: true },
    { id: "moca_score", minWidth: 150, filtered: false },
    { id: "eHealthId", minWidth: 400, filtered: true },
    { id: "dementia_diagnosis", minWidth: 200, filtered: true },
    { id: "is_dementia_mode", minWidth: 200, filtered: true },
    { id: "occupation", minWidth: 150, filtered: true },
    { id: "use_smartphone_level", minWidth: 250, filtered: true },
    { id: "education_level", minWidth: 150, filtered: true },
    { id: "mahjong_level", minWidth: 200, filtered: true },
    { id: "smoke", minWidth: 150, filtered: true },
    { id: "drink_alcohol", minWidth: 150, filtered: true },
    { id: "carer", minWidth: 200, filtered: true },
    { id: "followUp", minWidth: 250, filtered: true },
    { id: "memberId", minWidth: 200, filtered: true },
  ])
  const [allColumn, setAllColumn] = useState<boolean>(false);

  // Column Filter functions
  const [columnFilterOpen, setColumnFilterOpen] = useState<boolean>(false);
  const anchorColumnRef = useRef<any>(null);
  const prevColumnFilterOpen = useRef<boolean>(columnFilterOpen);
  
  const handleColumnFilterToggle = () => {
    setColumnFilterOpen((prevColumnFilterOpen: boolean) => !prevColumnFilterOpen);
  };

  const handleColumnFilterClose = (e: any) => {
    if (anchorColumnRef.current && anchorColumnRef.current.contains(e.target)) return;
    setColumnFilterOpen(false);
  }

  const handleColumnFilter = (id: string) => {
    if (id === "all") {
      setAllColumn(!allColumn);
      setColumns(
        columns.map( item => {
          if (item.id === "uid" || item.id === "center" || item.id === "name") { return item; }
          return {
            ...item,
            filtered: allColumn,
          }
        })
      )
    } else {
      if (allColumn) setAllColumn(false);
      setColumns(
        columns.map( item => {
          if (item.id !== id) { return item; }
          return {
            ...item,
            filtered: !item.filtered,
          }
        })
      )
    }
  }

  function handleListKeyDown(e: any) {
    if (e.key === "Tab") {
      e.preventDefault();
      setColumnFilterOpen(false);
      setDataFilterOpen(false);
    } else if (e.key === "Escape") {
      setColumnFilterOpen(false);
      setDataFilterOpen(false);
    }
  }

  useEffect(() => {
    if (prevColumnFilterOpen.current === true && columnFilterOpen === false) {
      anchorColumnRef.current.focus();
    }
    prevColumnFilterOpen.current = columnFilterOpen;
  }, [columnFilterOpen]);

  const calculateMocaScore = (scores: MocaScore): string => {
    // Check whether the score is of right type (because some are old types i.e. number only)
    if (scores && Number.isInteger(scores)) {
        return t("msg.format_need_update");
    } else if (scores && !Number.isInteger(scores) && scores.visuospatialExecutive === undefined) {
        return t("msg.invalid_record");
    }
    var total = 0;
    for (let [key, val] of Object.entries(scores)) {
      total += val;
    }
    return `${total} ${t("units_general.pt")}`;
  }

  // Search Function
  function handleSearch(e: any) {
    let showProfiles: UserProfile[] = [];

    if (e.target.value && e.target.value.replace(/\s/g, "").length) {
      let target: string = e.target.value.replace(/\s/g, "");
      let score_temp = e.target.value.replace(/[a-zA-Z]+/g, "");
      let score: number = parseInt(score_temp, 10);
      
      let target_gender_m = ("male".includes(target.toLocaleLowerCase()) || target === t("gender.male"));
      let target_gender_f = (("fe".includes(target.toLocaleLowerCase()) || "female".includes(target.toLocaleLowerCase())) || target === t("gender.female"));

      // let dementia_diagnosis_healthy = (target === t("dementia_diagnosis.healthy"));
      let dementia_diagnosis_healthy = (t("dementia_diagnosis.healthy").includes(target));
      let dementia_diagnosis_mci = (t("dementia_diagnosis.mci").includes(target));
      let dementia_diagnosis_mild_dementia = (t("dementia_diagnosis.mild_dementia").includes(target));
      let dementia_diagnosis_moderate_dementia = (t("dementia_diagnosis.moderate_dementia").includes(target));
      let dementia_diagnosis_severe_dementia = (t("dementia_diagnosis.severe_dementia").includes(target));
      let dementia_diagnosis_unknown = (t("dementia_diagnosis.unknown").includes(target));

      let use_smartphone_level_no_knowledge = (t("use_smartphone_level.no_knowledge").includes(target));
      let use_smartphone_level_newbie = (t("use_smartphone_level.newbie").includes(target));
      let use_smartphone_level_familiar = (t("use_smartphone_level.familiar").includes(target));
      let use_smartphone_level_unknown = (t("use_smartphone_level.unknown").includes(target));

      let education_level_no_education = (t("education_level.no_education").includes(target));
      let education_level_primary_school = (t("education_level.primary_school").includes(target));
      let education_level_secondary_school = (t("education_level.secondary_school").includes(target));
      let education_level_university = (t("education_level.university").includes(target));
      let education_level_above_university = (t("education_level.above_university").includes(target));
      let education_level_unknown = (t("education_level.unknown").includes(target));
      
      let mahjong_level_no_knowledge = (t("mahjong_level.no_knowledge").includes(target));
      let mahjong_level_newbie = (t("mahjong_level.newbie").includes(target));
      let mahjong_level_familiar = (t("mahjong_level.familiar").includes(target));
      let mahjong_level_unknown = (t("mahjong_level.unknown").includes(target));
      
      let common_level_no = (t("common_level.no").includes(target));
      let common_level_always = (t("common_level.always").includes(target));
      let common_level_sometimes = (t("common_level.sometimes").includes(target));
      let common_level_seldom = (t("common_level.seldom").includes(target));

      let no_record = (t("no__.record").includes(target));

      tableTempProfiles.filter(doc => 
        // admin only
        (userRole === "admin"? doc.center?.replace(/\s/g, "").includes(target) : false) ||
        (userRole === "admin"? doc.user_id?.includes(target) : false) ||

        // gender
        (target_gender_m? doc.gender?.includes("M") : false) ||
        (target_gender_f? doc.gender?.includes("F") : false) ||

        // dementia diagnosis
        (dementia_diagnosis_healthy? doc.dementia_diagnosis?.includes("healthy") : false) || 
        (dementia_diagnosis_mci? doc.dementia_diagnosis?.includes("mci") : false) || 
        (dementia_diagnosis_mild_dementia? doc.dementia_diagnosis?.includes("mild_dementia") : false) || 
        (dementia_diagnosis_moderate_dementia? doc.dementia_diagnosis?.includes("moderate_dementia") : false) || 
        (dementia_diagnosis_severe_dementia? doc.dementia_diagnosis?.includes("severe_dementia") : false) || 
        (dementia_diagnosis_unknown? doc.dementia_diagnosis?.includes("unknown") : false) || 

        // use smartphone level
        (use_smartphone_level_no_knowledge? doc.use_smartphone_level?.includes("no_knowledge") : false) || 
        (use_smartphone_level_newbie? doc.use_smartphone_level?.includes("newbie") : false) || 
        (use_smartphone_level_familiar? doc.use_smartphone_level?.includes("familiar") : false) || 
        (use_smartphone_level_unknown? doc.use_smartphone_level?.includes("unknown") : false) || 

        // education level
        (education_level_no_education? doc.education_level?.includes("no_education") : false) || 
        (education_level_primary_school? doc.education_level?.includes("primary_school") : false) || 
        (education_level_secondary_school? doc.education_level?.includes("secondary_school") : false) || 
        (education_level_university? doc.education_level?.includes("university") : false) || 
        (education_level_above_university? doc.education_level?.includes("above_university") : false) || 
        (education_level_unknown? doc.education_level?.includes("unknown") : false) || 

        // mahjong level
        (mahjong_level_no_knowledge? doc.mahjong_level?.includes("no_knowledge") : false) || 
        (mahjong_level_newbie? doc.mahjong_level?.includes("newbie") : false) || 
        (mahjong_level_familiar? doc.mahjong_level?.includes("familiar") : false) || 
        (mahjong_level_unknown? doc.mahjong_level?.includes("unknown") : false) || 

        // smoke and drink alcohol
        (common_level_no? doc.smoke?.includes("no") || doc.drink_alcohol?.includes("no") : false) || 
        (common_level_always? doc.smoke?.includes("always") || doc.drink_alcohol?.includes("always") : false) || 
        (common_level_sometimes? doc.smoke?.includes("sometimes") || doc.drink_alcohol?.includes("sometimes") : false) || 
        (common_level_seldom? doc.smoke?.includes("seldom") || doc.drink_alcohol?.includes("seldom") : false) || 

        // others
        doc.occupation?.replace(/\s/g, "").includes(target) ||
        doc.name?.replace(/\s/g, "").toLowerCase().includes(target.toLowerCase()) ||
        doc.year_of_birth?.toString().includes(target) ||
        doc.eHealthId?.replace(/\s/g, "").includes(target) ||
        doc.carer?.toLowerCase().includes(target.toLowerCase()) ||
        doc.memberId?.includes(target) ||
        doc.followUp?.includes(target) ||
        (doc.moca_score? parseInt(calculateMocaScore(doc.moca_score), 10) === score : false) ||
        (("yes".includes(e.target.value.toLocaleLowerCase()))? doc.is_dementia_mode : false) ||
        (("no".includes(e.target.value.toLocaleLowerCase()))? !doc.is_dementia_mode : false)
      ).forEach(doc => showProfiles.push(doc));
    } else {
      showProfiles = tableTempProfiles;
    }

    setTableProfiles(showProfiles);
    setPage(0);
  }

  // Data Filter functions
  const [dataFilterOpen, setDataFilterOpen] = useState<boolean>(false);
  const [dataFilterAttributes, setDataFilterAttributes] = useState<DataFilter[]>([
    { id: "gender", value: "all" },
    { id: "year_of_birth", value: "all", boundary: "="},
    { id: "moca_score", value: "all", boundary: "="},
    { id: "dementia_diagnosis", value: "all" },
    { id: "is_dementia_mode", value: "all" },
    { id: "occupation", value: "all" },
    { id: "use_smartphone_level", value: "all" },
    { id: "education_level", value: "all" },
    { id: "mahjong_level", value: "all" },
    { id: "smoke", value: "all" },
    { id: "drink_alcohol", value: "all" },
    { id: "carer", value: "all" },
    { id: "followUp", value: "all" },
    { id: "memberId", value: "all" },
  ]);
  const [isAll, setIsAll] = useState<boolean>(true);
  const anchorDataRef = useRef<any>(null);
  const prevDataFilterOpen = useRef<boolean>(dataFilterOpen);

  function handleDataFilterToggle() {
    setDataFilterOpen((prevDataFilterOpen: boolean) => !prevDataFilterOpen);
  }

  const handleDataFilterClose = (e: any) => {
    if (anchorDataRef.current && (anchorDataRef.current.contains(e.target))) return;
    setDataFilterOpen(false);
  }

  const handleDataFilter = (e: React.ChangeEvent<HTMLInputElement>, id: string) => {
    setDataFilterAttributes(dataFilterAttributes.map(item => {
      return (id !== item.id)? { ...item } : { ...item, value: e.target.value };
    }))
  }

  const handleDataInequality = (e: React.ChangeEvent<HTMLInputElement>, id: string) => {
    setDataFilterAttributes(dataFilterAttributes.map(item => {
      return (id !== item.id)? { ...item } : { ...item, boundary: e.target.value };
    }))
  }

  const handleDataFiltering = () => {
    let showProfiles: UserProfile[] = allProfiles;
    setIsAll(dataFilterAttributes.every(item => item.value === "all"));

    dataFilterAttributes.forEach(item => {
      if (item.value === "norecord") {
        showProfiles = showProfiles.filter(doc => !doc[item.id]);
      } else if (item.value !== "all") {
        if (item.id === "is_dementia_mode") {
          showProfiles = (item.value === "yes")? showProfiles.filter(doc => doc.is_dementia_mode) : showProfiles.filter(doc => !doc.is_dementia_mode);
        } else if (item.id === "year_of_birth") {
          let birthYear: number = parseInt(item.value, 10);
          if (item.boundary) {
            switch (item.boundary) {
              case "<":
                showProfiles = showProfiles.filter(doc => doc.year_of_birth? doc.year_of_birth < birthYear : false);
                break;
              case "<=":
                showProfiles = showProfiles.filter(doc => doc.year_of_birth? doc.year_of_birth <= birthYear : false);
                break;
              case ">=":
                showProfiles = showProfiles.filter(doc => doc.year_of_birth? doc.year_of_birth >= birthYear : false);
                break;
              case ">":
                showProfiles = showProfiles.filter(doc => doc.year_of_birth? doc.year_of_birth > birthYear : false);
                break;
              default:
                showProfiles = showProfiles.filter(doc => doc.year_of_birth? doc.year_of_birth === birthYear : false);
                break;
            }
          }
        } else if (item.id === "moca_score") {
          let score: number = parseInt(item.value, 10);
          if (item.boundary) {
            switch (item.boundary) {
              case "<":
                showProfiles = showProfiles.filter(doc => (doc.moca_score)? parseInt(calculateMocaScore(doc.moca_score), 10) < score : false);
                break;
              case "<=":
                showProfiles = showProfiles.filter(doc => (doc.moca_score)? parseInt(calculateMocaScore(doc.moca_score), 10) <= score : false);
                break;
              case ">=":
                showProfiles = showProfiles.filter(doc => (doc.moca_score)? parseInt(calculateMocaScore(doc.moca_score), 10) >= score : false);
                break;
              case ">":
                showProfiles = showProfiles.filter(doc => (doc.moca_score)? parseInt(calculateMocaScore(doc.moca_score), 10) > score : false);
                break;
              default:
                showProfiles = showProfiles.filter(doc => (doc.moca_score)? parseInt(calculateMocaScore(doc.moca_score), 10) === score : false);
                break;
            }
          }
        } else if (item.id === "occupation") {
          showProfiles = showProfiles.filter(doc => doc.occupation);
        } else {
          showProfiles = showProfiles.filter(doc => doc[item.id] === item.value)
        }
      }
    })
    setTableProfiles(showProfiles);
    setTableTempProfiles(showProfiles);
    setPage(0);
  }

  useEffect(() => {
    handleDataFiltering();
  }, [dataFilterAttributes])

  useEffect(() => {
    if (prevDataFilterOpen.current === true && dataFilterOpen === false) {
      anchorDataRef.current.focus();
    }
    prevDataFilterOpen.current = dataFilterOpen;
  }, [dataFilterOpen]);

  return (
    <div>
      <StyledContainer style={{ paddingTop: 90, paddingBottom: 80, maxWidth: "100%", maxHeight: "80%" }}>
        {
          (userRole === "admin" || userRole === "trial_center" || userRole === "center") &&
          <Toolbar
            sx={{
              pl: { sm: 2 },
              pr: { xs: 1, sm: 1 },
              justifyContent: "space-between",
            }}
          >
            <Button onClick={handleAddUserModalOpen} color="primary" variant="contained">
              {t("users.addUser")}
            </Button>
            <div style={{ display: "inline-flex", justifyContent: "space-between" }}>
              <Tooltip title={t("table_components.search")}>
                <Search sx={{ zIndex: 3 }}>
                  <StyledIconWrapper>
                    <SearchIcon/>
                  </StyledIconWrapper>
                  <StyledInputBase
                    inputProps={{ "aria-label": "search" }}
                    onChange={(e) => handleSearch(e)}
                  />
                </Search>
              </Tooltip>
              <Divider sx={{ height: "auto", m: 1 }} orientation="vertical" />
              <Tooltip title={t("table_components.columnFilter")}>
                <IconButton
                  ref={anchorColumnRef}
                  id="columnFilterButt"
                  aria-controls={columnFilterOpen ? "column-composition-menu" : undefined}
                  aria-expanded={columnFilterOpen ? "true" : undefined}
                  aria-haspopup="true"
                  onClick={handleColumnFilterToggle}
                >
                  <AlignHorizontalLeftIcon />
                </IconButton>
              </Tooltip>
              <Menu
                key="column-filter-menu"
                id="column-composition-menu"
                anchorEl={anchorColumnRef.current}
                onKeyDown={handleListKeyDown}
                open={columnFilterOpen}
                onClose={handleColumnFilterClose}
              >
                <MenuList
                  id="column-composition-menu"
                  aria-labelledby="composition-button"
                  onKeyDown={handleListKeyDown}
                >
                  <MenuItem key={`column-filter-all`} sx={{ padding: 0, paddingInline: 1, width: "100%", zIndex: 2 }} onClick={() => handleColumnFilter("all")}>
                    <Checkbox value="all" checked={allColumn}/>
                    All
                  </MenuItem>
                  {
                    columns.map((col) =>
                      ((col.roleValid && col.roleValid === userRole) || !col.roleValid) && (col.id !== "uid" && col.id !== "name" && col.id !== "center") && (
                        <MenuItem key={`column-filter-${col.id}`} sx={{ padding: 0, paddingInline: 1, width: "100%", zIndex: 2 }} onClick={() => handleColumnFilter(col.id)}>
                          <Checkbox
                            value={col.id}
                            checked={!col.filtered}
                          />
                          {t(`common.${col.id}` as unknown as TemplateStringsArray)}
                        </MenuItem>
                    ))
                  }
                </MenuList>
              </Menu>
              <Tooltip title={t("table_components.dataFilter")}>
                <IconButton
                  ref={anchorDataRef}
                  id="dataFilterButt"
                  aria-controls={dataFilterOpen ? "data-composition-menu" : undefined}
                  aria-expanded={dataFilterOpen ? "true" : undefined}
                  aria-haspopup="true"
                  onClick={handleDataFilterToggle}
                  color={!isAll? "warning" : "default"}
                >
                  <FilterListIcon/>
                </IconButton>
              </Tooltip>
              <Menu
                key={`data-filter-menu`}
                id="data-composition-menu"
                anchorEl={anchorDataRef.current}
                onKeyDown={handleListKeyDown}
                open={dataFilterOpen}
                onClose={handleDataFilterClose}
              >
                  {
                    dataAttributes.map((item, index) => {
                      if (item.id === "moca_score" || item.id === "year_of_birth") {
                        let isShowAll = dataFilterAttributes.find( currentItem => currentItem.id === item.id )?.value === "all";
                        let isNoRecord = dataFilterAttributes.find( currentItem => currentItem.id === item.id )?.value === "norecord";

                        return (
                          <div 
                            style={{ width: 200, display: "flex" }} 
                            key={`data-filter-${item.id}`}
                          >
                          <TextField
                            select
                            label={t(`common.${item.id}` as unknown as TemplateStringsArray)}
                            value={dataFilterAttributes.find( currentItem => currentItem.id === item.id )?.value}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleDataFilter(e, item.id)}
                            variant="standard"
                            key={`data-filter-${item.id}-value`}
                            sx={{ display: "inline-flex", margin: 1, width: (isShowAll || isNoRecord)? "100%" : "40%" }}
                          >
                            {
                              item.values.map(item_val => 
                                <MenuItem key={`data-filter-${item.id}-value=${item_val}`} value={item_val}>
                                  {/^\d+$/.test(item_val)? item_val : t(`${item.label}.${item_val}` as unknown as TemplateStringsArray)}
                                </MenuItem>
                              )
                            }
                          </TextField>
                          {
                            (!isShowAll && !isNoRecord) && (
                              <TextField
                                select
                                label=" "
                                value={dataFilterAttributes.find( currentItem => currentItem.id === item.id )?.boundary}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleDataInequality(e, item.id)}
                                variant="standard"
                                key={`data-filter-${item.id}-inequality`}
                                sx={{ display: "inline-flex", margin: 1, width: "60%" }}
                              >
                                {
                                  item.boundary?.map(sign => (
                                    <MenuItem key={`data-filter-${item.id}-inequality-${sign.id}`} sx={{ padding: 1 }} value={sign.values}>
                                      {t(`common.${sign.id}` as unknown as TemplateStringsArray)}
                                    </MenuItem>
                                  ))
                                }
                              </TextField>
                            )
                          }
                          </div>
                        )
                      } 
                      return (
                        <TextField
                          select
                          label={t(`common.${item.id}`)}
                          value={dataFilterAttributes.find( currentItem => currentItem.id === item.id )?.value}
                          onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleDataFilter(e, item.id)}
                          variant="standard"
                          key={`data-filter-${item.id}`}
                          sx={{ display: "flex", margin: 1, width: "auto" }}
                        >
                          {
                            item.values.map(item_val => (
                              <MenuItem key={`data-filter-${item.id}-value=${item_val}`} value={item_val}>
                                {t(`${item.label}.${item_val}` as unknown as TemplateStringsArray)}
                              </MenuItem>
                            ))
                          }
                        </TextField>
                      )
                    })
                  }
              </Menu>
            </div>
          </Toolbar>
        }
        {userProfiles && userProfiles.kind === "loading" && <StyledCircularProgress />}
        {
          userProfiles && userProfiles.kind === "loaded" && 
          <Paper sx={{ width: "100%", zIndex: -1 }}>
            <TableContainer sx={{ maxHeight: "60vh" }}>
              <Table stickyHeader aria-label="sticky table" sx={{ maxHeight: "80vh"}}>
                <CustomHead
                  userRole={userRole?? "unknown"}
                  order={order}
                  orderBy={orderBy}
                  columns={columns}
                  onRequestSort={handleRequestSort}
                />
                <TableBody>
                  <TableRow />
                  {
                    tableProfiles
                      .sort(getComparator(order, orderBy))
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map(thisUserProfile => {
                        if (thisUserProfile.user_id !== undefined) {
                          {console.log(thisUserProfile.user_id)}
                          {}
                          return (
                            <CustomRow
                              key={`user-${thisUserProfile.user_id}`}
                              userProfile={thisUserProfile}
                              columns={columns}
                              userRole={userRole?? "unknown"}
                              handleOpenGamePreferenceDialog={handleOpenGamePreferenceDialog}
                              handleEditDemoMissionDialog={handleEditDemoMissionDialog}
                              handleOpenEditUserDialog={handleOpenEditUserDialog}
                              handleDeleteDialogOpen={handleDeleteDialogOpen}
                              handleOpenResetPasswordDialog={handleOpenResetPasswordDialog}
                            />
                          )
                        }
                      })
                  }
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10, 20, 30, 50, 100]}
              component="div"
              count={tableProfiles.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              labelRowsPerPage={t("common.rows_per_page")}
              labelDisplayedRows={({ from, to, count }) => 
                `${from}-${to} ${t("common.of")} ${count !== -1 ? count : `${t("common.more_than")}${to}}`}`
              }
            />
          </Paper>  
        }
      </StyledContainer>

      {
        selectedUser !== undefined && deleteDialogOpen &&
        <DeleteDialog open={deleteDialogOpen} onClose={handleDeleteDialogClose} type="user" selectedName={selectedUser.name} selectedId={selectedUser.user_id} handleDelete={handleDeleteProfile} />
      }
      <SimpleSnackBar open={snackBar.open} onClose={closeErrorSnackBar} message={snackBar.message} variant={snackBar.variant} />
      {
        selectedUser !== undefined && openGamePreferenceDialog &&
        <GamePreferenceDialog userId={selectedUser.user_id} open={openGamePreferenceDialog} onClose={handleGamePreferenceDialogClose}/>
      }
      {
        selectedUserId !== undefined && isEditDemoMissionDialogOpen &&
        <EditDemoMissionDialog isOpen={isEditDemoMissionDialogOpen} onClose={closeEditDemoMissionDialog} uid={selectedUserId} isProfilePage={true} missionMetaData={missionMetadata.metadata} />
      }
      {
        selectedUserId !== undefined && isResetPasswordDialogOpen &&
        <ResetPasswordDialog isOpen={isResetPasswordDialogOpen} onClose={closeResetPasswordDialog} uid={selectedUserId} snackBar={snackBar} setSnackbar={setSnackBar} />
      }
      <SubmitGamePreferenceSnackBar open={openSubmitGamePreferenceSnackBar} onClose={handleSubmitGamePreferenceSnackBarClose}/>
      <AddUserDialog isOpen={isAddUserModalOpen} onClose={closeAddUserModal} user={selectedUser} allCenter={allCenter} />
    </div >
  );
}

//// Custom Table ////
const StyledTableCell = styled(TableCell)({
  padding: 14,
  align: "left",
})

interface Column {
  id:
    "uid" | 
    "name" | 
    "center" | 
    "gender" | 
    "year_of_birth" | 
    "moca_score" |
    "eHealthId" |
    "dementia_diagnosis" |
    "is_dementia_mode" | 
    "occupation" | 
    "use_smartphone_level" | 
    "education_level" | 
    "mahjong_level" | 
    "smoke" | 
    "drink_alcohol" |
    "carer" |
    "followUp" |
    "memberId";
  filtered?: boolean;
  roleValid?: string;
  minWidth?: number;
  align?: "left";
  format?: (value: number) => string;
}

interface DataAttributes {
  id: 
    "gender" | 
    "year_of_birth" | 
    "moca_score" |
    "dementia_diagnosis" |
    "is_dementia_mode" |
    "occupation" | 
    "use_smartphone_level" | 
    "education_level" | 
    "mahjong_level" | 
    "smoke" | 
    "drink_alcohol" |
    "carer" |
    "followUp" |
    "memberId";
  label: string;
  values: string[];
  boundary?: {
    id: string;
    values:
      ">" |
      ">="|
      "=" |
      "<="|
      "<";
  }[];
}

interface DataFilter {
  id: 
    "gender" | 
    "year_of_birth" | 
    "moca_score" |
    "dementia_diagnosis" |
    "is_dementia_mode" |
    "occupation" | 
    "use_smartphone_level" | 
    "education_level" | 
    "mahjong_level" | 
    "smoke" | 
    "drink_alcohol" |
    "carer" |
    "followUp" |
    "memberId";
  value: string;
  boundary?: string;
}

function Comparator(a: any, b: any, orderBy: string) {
  let res;
  if (orderBy === "moca_score") {
    let paramA: number = 0
    let paramB: number = 0

    if (a[orderBy]) Object.values(a[orderBy]).forEach((item: any) => paramA += item)
    if (b[orderBy]) Object.values(b[orderBy]).forEach((item: any) => paramB += item)

    res = (!paramB || (paramA && paramB && paramB < paramA))? -1 : (!paramA || (paramA && paramB && paramB > paramA))? 1 : 0;
  } else if (orderBy === "year_of_birth") {
    res = (b[orderBy] < a[orderBy] || !b[orderBy])? -1 : (b[orderBy] > a[orderBy] || !a[orderBy])? 1 : 0;
  } else {
    let paramA: string = ""
    let paramB: string = ""
    if (typeof a[orderBy] === "string") paramA = a[orderBy].toLowerCase()
    if (typeof b[orderBy] === "string") paramB = b[orderBy].toLowerCase()
    res = (!paramB || (paramA && paramB && paramB < paramA))? -1 : (!paramA || (paramA && paramB && paramB > paramA))? 1 : 0;
  }
  return res
}

function getComparator(order: "asc" | "desc", orderBy: string) {
  return order === "desc"
    ? (a: any, b: any) => Comparator(a, b, orderBy)
    : (a: any, b: any) => -Comparator(a, b, orderBy);
}

function CustomRow(
  props: {
    columns: Column[],
    userProfile: UserProfile,
    userRole: RoleType,
    handleOpenGamePreferenceDialog: (userProfile: UserProfile | undefined) => void,
    handleEditDemoMissionDialog: (uid: string) => void,
    handleOpenEditUserDialog: (userProfile: UserProfile | undefined) => void,
    handleDeleteDialogOpen: (userProfile: UserProfile | undefined) => void,
    handleOpenResetPasswordDialog: (uid: string) => void,
  }
) {
  const { t, i18n } = useTranslation()

  const calculateMocaScore = (scores: MocaScore): string => {
    // Check whether the score is of right type (because some are old types i.e. number only)
    if (scores && Number.isInteger(scores)) {
        return t("msg.format_need_update");
    } else if (scores && !Number.isInteger(scores) && scores.visuospatialExecutive === undefined) {
        return t("msg.invalid_record");
    }
    var total = 0;
    for (let [key, val] of Object.entries(scores)) {
      total += val;
    }
    return `${total} ${t("units_general.pt")}`;
  }

  const { 
    columns, 
    userProfile, 
    userRole, 
    handleOpenGamePreferenceDialog, 
    handleEditDemoMissionDialog, 
    handleOpenEditUserDialog, 
    handleDeleteDialogOpen,
    handleOpenResetPasswordDialog,
  } = props;
  const user_uid = userProfile.user_id;
  const user_key = `user-${user_uid}`;
  const user_moca_score = userProfile.moca_score? calculateMocaScore(userProfile.moca_score) : t("no__.record");
  const [open, setOpen] = useState(false);

  const handleRowHover = (e: any) => {
    if (e.target.id === user_uid) { setOpen(true); }
  }

  const handleRowLeave = (e: any) => {
    if (e.target.id === user_uid) { setOpen(false); }
  }

  return (
    <>
    <TableRow onMouseEnter={(e) => handleRowHover(e)} onMouseLeave={(e) => handleRowLeave(e)} hover sx={{ "& > *": {borderBottom: "unset" }}}>
      {
        userRole === "admin" && (
          <StyledTableCell id={user_uid}>{user_uid}</StyledTableCell>
        )
      }
      <StyledTableCell 
        id={user_uid}
        key={`${user_key}-uid-cell`}
        component="th" 
        scope="row"
      >
        {userProfile.name}
      </StyledTableCell>
      {
        userRole === "admin" && (
          <StyledTableCell id={user_uid} key={`${user_key}-center-cell`}>{userProfile.center?? ""}</StyledTableCell>
        )
      }
      {
        columns.map(col => {
          if (col.filtered) return;
          if (col.id === "moca_score") {
            return (
              <StyledTableCell id={user_uid} key={`${user_key}-moca_score-cell`}>
                {user_moca_score}
              </StyledTableCell>
            )
          }
          if (col.id === "is_dementia_mode") {
            return (
              <StyledTableCell id={user_uid} key={`${user_key}-dementia_mode-cell`}>
                {userProfile.is_dementia_mode? t("common.yes") : t("common.no")}
              </StyledTableCell>
            )
          }
          if (col.id === "gender" || col.id === "dementia_diagnosis" || col.id === "use_smartphone_level" || col.id === "education_level" || col.id === "mahjong_level") {
            return (
              <StyledTableCell id={user_uid} key={`${user_key}-${col.id}-cell`}>
                {userProfile[col.id]? t(`${col.id}.${userProfile[col.id]}` as unknown as TemplateStringsArray) : ""}
              </StyledTableCell>
            )
          }
          if (col.id === "smoke" || col.id === "drink_alcohol") {
            return (
              <StyledTableCell id={user_uid} key={`${user_key}-${col.id}-cell`}>
                {userProfile[col.id]? t(`common_level.${userProfile[col.id]}` as unknown as TemplateStringsArray) : ""}
              </StyledTableCell>
            )
          }
          if (col.id !== "uid" && col.id !== "name" && col.id !== "center") {
            return (
              <StyledTableCell id={user_uid} key={`${user_key}-${col.id}-cell`}>
                {userProfile[col.id]}
              </StyledTableCell>
            )
          }
        })
      }       
    </TableRow>   
    <TableRow onMouseEnter={(e) => handleRowHover(e)} onMouseLeave={(e) => handleRowLeave(e)} sx={{ backgroundColor: "#D3D3D3", width: "auto" }}>
      <TableCell sx={{ padding: 0 }} colSpan={18}>
        <Collapse in={open} timeout="auto" unmountOnExit>
            <div id={user_uid} style={{ padding: 5 }}>
              <Tooltip title={t("users.userIntegratedReport")}>
                <IconButton
                  href={'/report?uid=' + user_uid}
                  color="inherit"
                >
                  <AssessmentIcon color='primary' />
                </IconButton>
              </Tooltip>
              <Tooltip title={t("users.modifyUserGameSetting")}>
                <IconButton
                  onClick={() => handleOpenGamePreferenceDialog(userProfile)}
                  color="inherit"
                >
                  <BuildIcon color='primary' />
                </IconButton>
              </Tooltip>
              <Tooltip title={t("users.modifyUserMissionContent")}>
                <IconButton
                  onClick={() => handleEditDemoMissionDialog(user_uid)}
                  color="inherit"
                >
                  <SportsEsportsIcon color='primary' />
                </IconButton>
              </Tooltip>
              <Tooltip title={t("users.updateUserInfo")}>
                <IconButton
                  onClick={() => handleOpenEditUserDialog(userProfile)}
                  color="inherit"
                >
                  <EditIcon color='primary' />
                </IconButton>
              </Tooltip>
              { 
                (userRole === 'trial_center' || userRole === 'center') && 
                <Tooltip title={t("users.deleteUser")}>
                  <IconButton
                    onClick={() => handleDeleteDialogOpen(userProfile)}
                    color="inherit"
                  >
                    <DeleteIcon color='primary' />
                  </IconButton>
                </Tooltip>
              }
              {
                (userRole === "trial_center" || userRole === "center") &&
                <Tooltip title={t("users.resetPassword")}>
                  <IconButton
                    onClick={() => handleOpenResetPasswordDialog(user_uid)}
                    color="inherit"
                  >
                    <VpnKeyIcon color='primary' />
                  </IconButton>
                </Tooltip>
              }
            </div>
        </Collapse>
      </TableCell>
    </TableRow>
    </>
  )
}

function CustomHead(
  props: {
    userRole: RoleType,
    order: "asc" | "desc" ,
    orderBy: string,
    columns: Column[],
    onRequestSort: (arg0: any, arg1: string) => void,
  }
) {

  const { userRole, order, orderBy, columns, onRequestSort } = props;
  const {t} = useTranslation();
  const createSortHandler = (property: string) => (e: any) => {
    onRequestSort(e, property);
  };

  return (
    <TableHead>
      <TableRow>
        {
          columns.map((col) => {
            return (
              // Check user role type 
              // Case 1: if roleValid exist and userRole === roleValid
              // Case 2: if roleValid not exist
              // result: show the column head
              (((col.roleValid && col.roleValid === userRole) || (!col.roleValid)) && !col.filtered) &&
                <StyledTableCell
                  key={col.id}
                  align={col?.align?? "left"}
                  style={{ minWidth: col.minWidth }}
                  sortDirection={orderBy === col.id ? order : false}
                >
                  <TableSortLabel
                    active={orderBy === col.id}
                    direction={orderBy === col.id ? order : "asc"}
                    onClick={createSortHandler(col.id)}
                  >
                    {t(`common.${col.id}`)}
                    {
                      orderBy === col.id ? (
                        <Box component="span" sx={visuallyHidden}>
                          {order === "desc" ? "sorted descending" : "sorted ascending"}
                        </Box>
                      )
                      : null
                    }
                  </TableSortLabel>
                </StyledTableCell>
            )
          })
        }
      </TableRow>
    </TableHead>
  )
}

const Search = styled("div")(({theme}) => ({
  position: "relative",
  marginLeft: 0,
  marginRight: 7,
  width: "100%",
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(1),
    width: 'auto',
  },
}))

const StyledIconWrapper = styled("div")(({theme}) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}))

const StyledInputBase = styled(InputBase)(({theme}) => ({
  "& .MuiInputBase-input": {
    padding: theme.spacing(1,1,1,0),
    borderRadius: "25px",
    paddingLeft: "3em",
    paddingRight: "0",
    transition: theme.transitions.create("width"),
    [theme.breakpoints.up('sm')]: {
      width: 0,
      '&:hover': {
        width: '20ch',
        backgroundColor: alpha("#BBBBBB", 0.25),
      },
      '&:focus': {
        width: '20ch',
        backgroundColor: alpha("#BBBBBB", 0.25),
      },
    },
  }
}))

// Original MUI data table script 
// Directly replace with the current table
{/* {userProfiles !== undefined && userProfiles.kind === "loaded" &&
          userRole === "admin" ?
          <>
          <MUIDataTable
            title={""}
            data={userProfiles.data}
            columns={[
              {
                label: ' ',
                name: 'user_id',
                options: {
                  filter: false,
                  sort: false,
                  viewColumns: false,
                  customBodyRender: (value) => (
                    <>
                      <Tooltip title="玩家詳細報告">
                        <IconButton href={'/report?uid=' + value} color="inherit">
                          <AssessmentIcon color='primary' />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="更改玩家遊戲設定">
                        <IconButton
                          onClick={() => handleOpenGamePreferenceDialog(userProfiles.data.find(x => x.user_id === value))}
                          color="inherit"
                        >
                          <BuildIcon color='primary' />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="更改玩家資料">
                        <IconButton
                          onClick={() => handleOpenEditUserDialog(userProfiles.data.find(x => x.user_id === value))}
                          color="inherit"
                        >
                          <EditIcon color='primary' />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="刪除玩家(已停用)">
                        <IconButton
                          onClick={() => handleDeleteDialogOpen(userProfiles.data.find(x => x.user_id === value))}
                          color="inherit"
                        >
                          <DeleteIcon color='primary' />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="更改玩家任務內容">
                        <IconButton
                          onClick={() => handleEditDemoMissionDialog(value)}
                          color="inherit"
                        >
                          <SportsEsportsIcon color='primary' />
                        </IconButton>
                      </Tooltip>
                    </>
                  )
                }
              },
              {
                label: 'UID',
                name: 'user_id',
                options: {
                  filter: false,
                  sort: true,
                }
              },
              {
                label: '用家',
                name: 'name',
                options: {
                  filter: false,
                  sort: true,
                }
              },
              {
                label: '所屬團體',
                name: 'center',
                options: {
                  filter: true,
                  sort: true,
                }
              },
              {
                label: '性別',
                name: 'gender',
                options: {
                  filter: true,
                  sort: true,
                }
              },
              {
                label: '出生年份',
                name: 'year_of_birth',
                options: {
                  filter: true,
                  sort: true,
                }
              },
              {
                label: '腦退化症診斷結果',
                name: 'dementia_diagnosis',
                options: {
                  filter: true,
                  sort: true,
                  display: "false"
                }
              },
              {
                label: '簡化模式',
                name: 'is_dementia_mode',
                options: {
                  filter: true,
                  sort: true,
                  customBodyRender: (value) => value ? "Yes" : "No",
                  display: "false"
                }
              },
              {
                label: 'MOCA分數',
                name: 'moca_score',
                options: {
                  filter: false,
                  sort: true,
                  customBodyRender: (value) => value ? calculateMocaScore(value) : "無記錄"
                }
              },
              {
                label: '職業 (曾任/現任)',
                name: 'occupation',
                options: {
                  filter: true,
                  sort: true,
                  display: "false"
                }
              },
              {
                label: '使用智能電話/平板電腦的熟悉度',
                name: 'use_smartphone_level',
                options: {
                  filter: true,
                  sort: true,
                  display: "false"
                },
              },
              {
                label: '教育程度',
                name: 'education_level',
                options: {
                  filter: true,
                  sort: true,
                  display: "false"
                },
              },
              {
                label: '打麻雀熟悉度',
                name: 'mahjong_level',
                options: {
                  filter: true,
                  sort: true,
                  display: "false"
                },
              },
              {
                label: '吸煙習慣',
                name: 'smoke',
                options: {
                  filter: true,
                  sort: true,
                  display: "false"
                },
              },
              {
                label: '飲酒習慣',
                name: 'drink_alcohol',
                options: {
                  filter: true,
                  sort: true,
                  display: "false"
                },
              },
              {
                label: 'E-Health ID',
                name: 'eHealthId',
                options: {
                  filter: true,
                  sort: true,
                  display: "false"
                },
              },
            ]}
            options={{ selectableRows: 'none', elevation: 0, print: false, download: false }} />
            </>
            :
          userProfiles.kind === "loaded" && userRole !== undefined &&
          <>
           <MUIDataTable
            title={""}
            data={userProfiles.data}
            columns={[
              {
                label: ' ',
                name: 'user_id',
                options: {
                  filter: false,
                  sort: false,
                  viewColumns: false,
                  customBodyRender: (value) => (
                    <>
                      <Tooltip title="玩家詳細報告">
                        <IconButton
                          href={'/report?uid=' + value}
                          color="inherit"
                        >
                          <AssessmentIcon color='primary' />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="更改玩家遊戲設定">
                        <IconButton
                          onClick={() => handleOpenGamePreferenceDialog(userProfiles.data.find(x => x.user_id === value))}
                          color="inherit"
                        >
                          <BuildIcon color='primary' />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="更改玩家任務內容">
                        <IconButton
                          onClick={() => handleEditDemoMissionDialog(value)}
                          color="inherit"
                        >
                          <SportsEsportsIcon color='primary' />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="更改玩家資料">
                        <IconButton
                          onClick={() => handleOpenEditUserDialog(userProfiles.data.find(x => x.user_id === value))}
                          color="inherit"
                        >
                          <EditIcon color='primary' />
                        </IconButton>
                      </Tooltip>
                      {(userRole === 'trial_center' || userRole === 'center') && <Tooltip title="刪除玩家">
                        <IconButton
                          onClick={() => handleDeleteDialogOpen(userProfiles.data.find(x => x.user_id === value))}
                          color="inherit"
                        >
                          <DeleteIcon color='primary' />
                        </IconButton>
                      </Tooltip>}
                    </>
                  )
                }
              },
              {
                label: 'UID',
                name: 'user_id',
                options: {
                  filter: false,
                  sort: true,
                }
              },
              {
                label: '用家',
                name: 'name',
                options: {
                  filter: false,
                  sort: true,
                }
              },
              {
                label: '性別',
                name: 'gender',
                options: {
                  filter: true,
                  sort: true,
                }
              },
              {
                label: '出生年份',
                name: 'year_of_birth',
                options: {
                  filter: true,
                  sort: true,
                }
              },
              {
                label: '腦退化症診斷結果',
                name: 'dementia_diagnosis',
                options: {
                  filter: true,
                  sort: true,
                  display: "false"
                }
              },
              {
                label: '簡化模式',
                name: 'is_dementia_mode',
                options: {
                  filter: true,
                  sort: true,
                  customBodyRender: (value) => value ? "Yes" : "No",
                  display: "false"
                }
              },
              {
                label: 'MOCA分數',
                name: 'moca_score',
                options: {
                  filter: false,
                  sort: true,
                  customBodyRender: (value) => value ? calculateMocaScore(value) : "無記錄"
                }
              },
              {
                label: '職業 (曾任/現任)',
                name: 'occupation',
                options: {
                  filter: true,
                  sort: true,
                  display: "false"
                }
              },
              {
                label: '使用智能電話/平板電腦的熟悉度',
                name: 'use_smartphone_level',
                options: {
                  filter: true,
                  sort: true,
                  display: "false"
                },
              },
              {
                label: '教育程度',
                name: 'education_level',
                options: {
                  filter: true,
                  sort: true,
                  display: "false"
                },
              },
              {
                label: '打麻雀熟悉度',
                name: 'mahjong_level',
                options: {
                  filter: true,
                  sort: true,
                  display: "false"
                },
              },
              {
                label: '吸煙習慣',
                name: 'smoke',
                options: {
                  filter: true,
                  sort: true,
                  display: "false"
                },
              },
              {
                label: '飲酒習慣',
                name: 'drink_alcohol',
                options: {
                  filter: true,
                  sort: true,
                  display: "false"
                },
              },
              {
                label: 'E-Health ID',
                name: 'eHealthId',
                options: {
                  filter: true,
                  sort: true,
                  display: "false"
                },
              },

            ]}
            options={{ selectableRows: 'none', elevation: 0, print: false, download: false }} />
          </>
          }  */}